const buildPopups = () => {
  Array.from(document.querySelectorAll('.popup')).forEach((popup) => {
    const closeIcon = document.createElement('button');
    closeIcon.className = 'close-popup';
    closeIcon.innerText = '×';

    const insertedCloseIcon = popup.querySelector('.container .inner').appendChild(closeIcon);
    insertedCloseIcon.addEventListener('click', (event) => {
      event.preventDefault();
      popup.classList.toggle('open');

      if (popup.classList.contains('open')) {
        document.body.classList.add('popup-is-open');
      } else {
        document.body.classList.remove('popup-is-open');
      }
    });

    popup.querySelector('.bg').addEventListener('click', () => {
      popup.classList.toggle('open');

      if (popup.classList.contains('open')) {
        document.body.classList.add('popup-is-open');
      } else {
        document.body.classList.remove('popup-is-open');
      }
    });
  });


  Array.from(document.querySelectorAll('.toggle-popup-window')).forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();

      // Get the popup target
      let popupID = link.getAttribute('href');

      // Remove the # from the ID
      popupID = popupID.replace('#', '');

      // Fetch the popup
      const popup = document.getElementById(popupID);

      // Toggle open class on the popup
      popup.classList.toggle('open');
      if (popup.classList.contains('open')) {
        document.body.classList.add('popup-is-open');
      } else {
        document.body.classList.remove('popup-is-open');
      }
    });
  });


  Array.from(document.querySelectorAll('.toggle-slide-in')).forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();

      // Get the popup target
      let popupID = link.getAttribute('href');

      // Remove the # from the ID
      popupID = popupID.replace('#', '');

      // Fetch the popup
      const popup = document.getElementById(popupID);

      // Toggle open class on the popup
      popup.classList.toggle('open');
      if (popup.classList.contains('open')) {
        document.body.classList.add('slide-in-is-open');
      } else {
        document.body.classList.remove('slide-in-is-open');
      }
    });
  });
};


setTimeout(() => {
  buildPopups();
}, 10);
jQuery(document.body).on('updated_cart_totals', buildPopups);
